import React from "react";
import { connect } from "react-redux";
import { Redirect } from 'react-router'
import {
  fetchContacts,
  fetchUserCompany,
  addRequestWithFiles,
} from "../../store/actions/index";
import axios from "../../axios-atis";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import moment from "moment";

import {
  Breadcrumb,
  Button,
  FormGroup,
  Col,
  FormControl,
  ControlLabel,
  Form,
  Panel,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import TagsInput from 'react-tagsinput'
//import 'react-tagsinput/react-tagsinput.css'
import RequestContact from "../../components/UI/Widget/RequestContact";
import { isA, isReporter } from "../../store/utility";
import UploadZone from "./UploadZone";

class NewAdminRequest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: true,
      error: null,
      requestResume: { value: "", isValid: true, message: "" },
      name: { value: "", isValid: true, message: "" },
      company: { value: "", isValid: true, message: "" },
      section: { value: "", isValid: true, message: "" },
      aknowledgement: { value: true, isValid: true, message: "" },
      creationDate: { value: moment(), isValid: true, message: "" },
      contacts: [],
      selectedContacts: [],
      companies: [],
      request: null,
      //requests: null,
      isSending: false,
      files: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    const { contacts, loaded, companies } = this.state;
    
    if (nextProps.request && nextProps.request.redirectTo) {
      this.props.history.push(nextProps.request.redirectTo);
      //this.setState({request: nextProps.request})
    } 
    if (nextProps.contacts  && contacts !== nextProps.contacts) {
        this.setState({ 
          contacts: nextProps.contacts,
          selectedContacts: nextProps.contacts
        });
    }
    if (loaded !== nextProps.loaded) {
      this.setState({ loaded: nextProps.loaded });
    }
    if (nextProps.companies && companies !== nextProps.companies) {
      this.setState({ companies: nextProps.companies });
    }
  }

  componentDidMount() {
    this.props.dispatch(fetchContacts());
    this.props.dispatch(fetchUserCompany());
  }

  switchHandler = (event) => {
    var state = this.state;
    state[event.target.id].value = !state[event.target.id].value;
    this.setState(state);
  };

  inputChangeHandler = (event) => {
    var state = this.state;
    state[event.target.id].value = event.target.value;
    this.setState(state);
  };

  validateForm = () => {
    return (
      this.state.name.value.length > 0 &&
      this.state.requestResume.value.length &&
      this.state.company.value.length > 0
    );
  };

  submitHandler = (event) => {
    event.preventDefault();
    var _contacts = [];

    for (var i = 0; i < this.state.selectedContacts.length; i++) {
      var selectedContact = this.state.selectedContacts[i];
      var contact = {};
      if (selectedContact.value === selectedContact.label) {
        contact = {
          id: null,
          email: selectedContact.label,
        };
      } else {
        contact = {
          id: selectedContact.value,
          email: selectedContact.label,
        };
      }
      _contacts.push(contact);
    }
    var requestCompany = this.props.companies.filter(
      (c) => c.name === this.state.company.value
    );
    if (requestCompany.length === 1) {
      var _request = {
        name: this.state.name.value,
        request: this.state.requestResume.value,
        company: requestCompany.pop(),
        section: this.state.section.value,
        contacts: _contacts,
      };
      const data = new FormData();
      const { files } = this.state;
      
      for (let i = 0; i < files.length; i++) {
        data.append("files", files[i]);
      }
      const json = JSON.stringify(_request);
      const blob = new Blob([json], { type: "application/json" });
      data.append("request", blob);
      
      
      this.props.dispatch(addRequestWithFiles(data));
      this.setState({ isSending: true });
    }
  };

  buildOptions(sections) {
    sections.sort((a, b) => a.label.trim().localeCompare(b.label.trim(), "fr-FR"));
    var options = sections.map(function (section, index) {
      if (section.enabled)
        return (
          <option key={index} value={section.label}>
            {section.label}
          </option>
        );
      return null;
    });

    return options;
  }

  buildCompanyOptions(companies) {
    companies.sort((a, b) => a.name.trim().localeCompare(b.name.trim(), "fr-FR"));
    // 22/10/2026 : clients desactives non proposes
    var options = companies.filter((c) => c.activated !== false).map(function (company, index) {
      return (
        <option key={index} value={company.name}>
          {company.name}
        </option>
      );
    });

    return options;
  }

  setContacts = (contacts) => {
    this.setState({ selectedContacts: contacts });
  };

  setFiles = (files) => {
    this.setState({ files: files });
  };

  render() {
    if (!isA() && !isReporter()) {
      return null;
    }
    
    const { companies, company, contacts } = this.props;
    const { isSending, loaded, creationDate } = this.state;

    const requestDate = creationDate.value;
    const createDateLbl = requestDate.format('YYYY-MM-DD')
    
    if (!companies || !company || loaded) {
      return null;
    }
    
    var selectedCompany;
    var companyContacts = [];

    if (contacts) {
      for (var i = 0; i < companies.length; i++) {
        if (this.state.company.value === companies[i].name) {
          selectedCompany = companies[i];

          for (var j = 0; j < this.props.contacts.length; j++) {
            if (contacts[j].company.id === selectedCompany.id) {
              companyContacts.push(this.props.contacts[j]);
            }
          }
          break;
        }
      }
    }


    return (
      
      <div className="content-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item href="/#/requests">Interventions</Breadcrumb.Item>
          <Breadcrumb.Item active>Nouvelle demande</Breadcrumb.Item>
        </Breadcrumb>
        <Panel>
          <Panel.Body>
            <Form onSubmit={this.submitHandler} horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Titre
                </Col>
                <Col sm={10}>
                  <FormControl
                    type="text"
                    value={this.state.name.value}
                    id="name"
                    className="form-control"
                    onChange={(event) => this.inputChangeHandler(event)}
                    placeholder="Renseignez le titre de votre demande d'intervention"
                  />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Société
                </Col>
                <Col sm={4}>
                  <FormControl
                    componentClass="select"
                    placeholder="Société"
                    id="company"
                    onChange={(event) => this.inputChangeHandler(event)}
                    value={this.state.company.value}
                  >
                    <option value="" />
                    {this.buildCompanyOptions(companies)}
                  </FormControl>
                </Col>
                {selectedCompany && selectedCompany.sections.length > 0 ? (
                  <Col componentClass={ControlLabel} sm={2}>
                    Site
                  </Col>
                ) : null}
                {selectedCompany && selectedCompany.sections.length > 0 ? (
                  <Col sm={4}>
                    <FormControl
                      componentClass="select"
                      placeholder="Site"
                      id="section"
                      onChange={(event) => this.inputChangeHandler(event)}
                      value={this.state.section.value}
                    >
                      <option value="" />
                      {this.buildOptions(selectedCompany.sections)}
                    </FormControl>
                  </Col>
                ) : null}
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Créée le
                </Col>
                <Col sm={4}>
                <FormControl
                    type="date"
                    value={createDateLbl}
                    id="name"
                    disabled={true}

                    className="form-control"
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={3}>
                  Accusé de reception
                </Col>
                <Col sm={3}>
                  <label className="switch">
                    <FormControl
                      id="aknowledgement"
                      type="checkbox"
                      defaultChecked
                      onChange={(event) => this.switchHandler(event)}
                      value={this.state.aknowledgement.value}
                    />
                    <em />
                  </label>
                </Col>
              </FormGroup>
              {this.state.aknowledgement.value ? (
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>
                    Envoyé à
                  </Col>
                  <Col sm={10}>
                    <RequestContact
                      contacts={companyContacts}
                      requestContacts={companyContacts}
                      setContacts={(value) => this.setContacts(value)}
                      canUpdate={true}
                    />
                  </Col>
                </FormGroup>
              ) : null}
              <FormGroup>
                <Col sm={9}>
                  <Panel>
                    <Panel.Heading>
                      <Panel.Title>Résumé de la demande</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                      <textarea
                        rows="10"
                        id="requestResume"
                        className="form-control note-editor"
                        onChange={(event) => this.inputChangeHandler(event)}
                        value={this.state.requestResume.value}
                      />
                    </Panel.Body>
                  </Panel>
                </Col>
                <Col sm={3}>
                  <UploadZone setFiles={(values) => this.setFiles(values)} style={{ height:'100%!important' }}/>
                </Col>
              </FormGroup>
              <Button
                type="submit"
                disabled={!this.validateForm() || isSending}
                className="btn btn-block btn-primary mt-lg"
              >
                <span className="fa fa-send" />
                &nbsp;Envoyer
              </Button>
            </Form>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    error: state.contact.error,
    contacts: state.contact.contacts.filter((c) => c.enabled === true),
    loaded: state.contact.loading || state.company.loading || state.auth.loading,
    company: state.auth.company,
    companies: state.company.companies,
    request: state.request,
  };
};

export default connect(mapStateToProps) (
  withErrorHandler(NewAdminRequest, axios)
);



// WEBPACK FOOTER //
// ./src/containers/Request/NewAdminRequest.js